/*
 * @Author: bbqin
 * @Date: 2021-07-20 10:15:52
 * @LastEditTime: 2021-08-12 18:32:00
 * @LastEditors: bbqin
 * @Description: 啥功能呢
 * @FilePath: \Platform_Front\src\platform\base\Calculator\utils.js
 * 这锅我不背
 */
export function isNumber(item) {
    let test = /[0-9]/.test(item);
    // console.log(test);
    return test;
}